import {useQuery} from '@tanstack/react-query';
import {UserApi} from 'app/components/entities/user';

export function usePolicyQuery() {
  return useQuery({
    queryKey: ['policy'],
    queryFn: async () => UserApi.getPolicy(),
  });
}
